import { store } from '@/store';
const MainHeader = () => import('@/components/MainHeader');
const Register = () => import('@/views/register/Home');
const Otp = () => import('@/views/register/Otp');

export default [
    {
        path: '/:type(car|motor)/register',
        name: 'Register',
        components: {
            default: Register,
            header: MainHeader
        },
        props: (route) => route.params,
        beforeEnter: (to, from, next) => {
            if (store.getters['auth/loggedIn']) {
                return next(from.path);
            }
            next();
        }
    },
    {   /* 查詢結果 */
        path: '/:type(car|motor)/register/otp',
        name: 'RegisterOtp',
        components: {
            default: Otp,
            header: MainHeader
        },
        props: {
            default: (route) => route.params,
            header: false
        },
        beforeEnter: (to, from, next) => {
            if (store.getters['auth/loggedIn']) {
                return next(from.path);
            } else if (!store.getters['otp/registerOtpCodeAvailable']) {
                return next('/register');
            }
            next();
        }
    }
];